// Показателите на „Монитори".
//
// Обобщението идва от `summarizeKitchenMonitorRows` върху ПОКАЗАНИТЕ редове —
// кутийките следват търсачката, както таблицата и Excel.
//
// Средните времена се показват четимо („4m 05s"), не в голи секунди; липсващ
// среден престой (никой ред не е минал през статуса) остава тире.

import { useTranslation } from "react-i18next";

import { ReportKpiCard } from "../ReportKpiCard";
import { formatDuration } from "./kitchenMonitorsFormat";
import type { KitchenMonitorReportSummary } from "../../../../api/reportsKitchenMonitors";

type Props = {
  summary: KitchenMonitorReportSummary;
  isNarrow: boolean;
};

export const KitchenMonitorsKpis = ({ summary, isNarrow }: Props) => {
  const { t } = useTranslation();

  // Четирите фази на реда в реда, в който се случват: приет → започнат →
  // сготвен → издаден → сервиран.
  const averages = [
    {
      id: "to_start",
      label: t("reportsPage.kmStatusInProgress"),
      seconds: summary.avg_seconds_to_start,
    },
    {
      id: "cooking",
      label: t("reportsPage.kmStatusCooked"),
      seconds: summary.avg_seconds_cooking,
    },
    {
      id: "to_issue",
      label: t("reportsPage.kmStatusIssued"),
      seconds: summary.avg_seconds_to_issue,
    },
    {
      id: "to_serve",
      label: t("reportsPage.kmStatusServed"),
      seconds: summary.avg_seconds_to_serve,
    },
  ];

  return (
    // Класовете са ЦЕЛИ литерали: Tailwind сканира изходния текст и не вижда
    // име, сглобено с template literal.
    <div
      className={`grid gap-2.5 ${
        isNarrow ? "grid-cols-2" : "grid-cols-2 lg:grid-cols-5"
      }`}
    >
      <ReportKpiCard
        kicker={t("reportsPage.kmRowsKpi")}
        value={String(summary.items_count)}
        sub={t("reportsPage.kmRowsKpiSub")}
        hero
      />

      {averages.map((average) => (
        <ReportKpiCard
          key={average.id}
          kicker={average.label}
          value={formatDuration(average.seconds)}
          sub={t("reportsPage.kmAvgKicker")}
        />
      ))}
    </div>
  );
};
